<template>
    <div>
        <!-- {{listData}} -->
        <!-- <ul class="newLists" v-if="newListStyle1 && listData.length > 0">
            <li v-for="(item, index) in listData" :key="index">
                <a class="listStyle1 fl" :postid="item.id" @click="associationNewsDetail(item.id)">{{item.title}}</a>
            </li>
        </ul> -->

        <ul class="newLists" v-if="newListStyle2 && listData.length > 0">
            <li v-for="(item, index) in listData" :key="index">
                <a class="listStyle2 fl" :postid="item.id" @click="associationNewsDetail(item.id)">{{item.title}}
                </a>
                <span class="newsTime fr">{{item.published_time}}</span>
            </li>
        </ul>

        <ul class="newLists" v-if="newListStyle3 && listData.length > 0">
            <li v-for="(item, index) in listData" :key="index">
                <a class="listStyle2 fl" :postid="item.id" @click="associationNewsDetail(item.id)">{{item.title}}</a>
                <div class="newsTime fr">发布时间：{{item.published_time}}</div>
            </li>
        </ul>

        <p class="noNewListTips" v-if="listData.length == 0">暂无数据,敬请期待！</p>
    </div>
</template>

<script>
export default {
    props: {
        listData: {
            type: Array,
            default: []
        },
        newListStyle1: {
            type: Boolean,
            default: false
        },
        newListStyle2: {
            type: Boolean,
            default: false
        },

        newListStyle3: {
            type: Boolean,
            default: false
        },
        orignIndexModuleIdx: {
            type: Number,
            default: 0
        }


        // currentNavIdx: {
        //     type:Number,
        //     default:0
        // },
    },

    data () {
        return {
            isActive: 0,
            idx: 0,
            loadingFlg: 0
        };
    },
    mounted () {
        // console.log(this.listData)
        if (window.location.href.split('?')[1]) {
            this.idx = this.getQueryVariable('currentNavIdx')
        }
    },
    methods: {
        /**
         * 跳转详情页
         */
        associationNewsDetail (postid) {
            let associationNewsDetailParams = {
                postid: postid
            };
            this.$router.push({
                path: "/associationNewsDetail",
                query: {
                    postid: postid,
                    currentNavIndex: this.idx || this.orignIndexModuleIdx,
                    newsId: this.$route.query.newsId || this.orignIndexModuleIdx
                }
            });

            // this.$store.dispatch("navCategoryPage", associationNewsDetailParams)
            //     .then(res => {
            //         if (res.code == 200) {
            //             this.$router.push({
            //                 path: "/associationNewsDetail",
            //                 query: { 
            //                     postid: postid, 
            //                     currentNavIndex: this.idx || this.orignIndexModuleIdx,
            //                     newsId:this.$route.query.newsId || this.orignIndexModuleIdx
            //                 }
            //             });
            //         }
            //     }).catch(error => {
            //         console.log('错误信息：', error)
            //     });
        },
        /**
         * 获取地址栏参数
         */
        getQueryVariable (variable) {

            var reg = window.location.href.split('?')[1].split('&');
            var obj = {};
            for (var i in reg) {
                let key = reg[i].split('=');
                obj[key[0]] = key[1];
            }
            return obj[variable];
        }
    }
};
</script>

<style scoped>
.newLists {
    width: 100%;
}

.newLists li {
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 10px 2px 10px 24px;
    position: relative;
    cursor: pointer;
}
.newLists li:last-child {
    /* padding-bottom :0; */
}

.newLists li a {
    color: rgba(51, 51, 51, 1);
    display: block;
    font-size: 14px;
}

.newLists li a:hover {
    color: #0173ff;
}
.newLists li:before {
    position: absolute;
    width: 4px;
    height: 4px;
    content: "";
    border-radius: 180px;
    background: #4c9bfd;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.listStyle1 {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.listStyle2 {
    width: 72%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.newsTime {
    color: #999;
}

.noNewListTips {
    text-align: center;
    margin-top: 100px;
    color: #999;
    letter-spacing: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/commonNewList.vue